import { FC, ReactElement } from "react"

import { Tooltip } from "../../../components/mui.components"

const UTooltip: FC<{
  titleContent: ReactElement | string
  children: ReactElement
  placement?: "bottom" | "top" | "left" | "right"
}> = ({ titleContent, children, placement }) => {
  return (
    <Tooltip
      title={titleContent}
      placement={placement || "top"}
      arrow
      slotProps={{
        tooltip: {
          style: {
            padding: 0,
            marginBottom: "7px",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  )
}

export default UTooltip
